module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Repeat-262804310813a92fae8e6cb4a48d6dbe.svg";